    <div class="MainBg mt-3" *ngIf="IsMobile">
        <div class="NewHeadOuter">
            <div>
                <div class="SectionTopHeading_n">Investment Summary</div>
            </div>
            <a class="RightSideLink" routerLinkActive="active"><i class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Report
                Dashboard </a>
        </div>

        <div class="NewHeadOuter SipCountOuter DotTabsContent">
            <div class="SipBox">
                <div class="SchemeHeader">Total Value at Cost</div>
                <div class="SubHeader">{{TotalvalueatCost}}</div>
            </div>
            <div class="SipBox">
                <div class="SchemeHeader">Total MF Value at Cost</div>
                <div class="SubHeader">{{TotalMFvalueatCost}}</div>
            </div>
            <div class="SipBox">
                <div class="SchemeHeader">MF Portfolio Value</div>
                <div class="SubHeader">{{MFPortfoliovalue}}</div>
            </div>
            <div class="SipBox">
                <div class="SchemeHeader">Unrealised Gain / Loss</div>
                <div class="SubHeader">{{UnrealisedGainOrLoss}}</div>
            </div>
            <div class="SipBox">
                <div class="SchemeHeader">MF XIRR(%)</div>
                <div class="SubHeader">{{MFXirr}}</div>
            </div>
            <div class="SipBox">
                <div class="SchemeHeader">Inception Date</div>
                <div class="SubHeader">{{InsecptionDATE}}</div>
            </div>
        </div>

        <div class="NewHeadOuter DotTabsContent chart_mob">
            <!-- <highcharts-chart ></highcharts-chart> -->
            <div id="OverallProductChart"></div>


        </div>
        <div class="NewHeadOuter DotTabsContent">
            <div class="table-responsive table-container">
                <table id="dataTable_tally_sheet" width="100%" class="CommonTable ClsReportTable nowrap">
                    <thead>
                        <tr>
                            <th>MF Portfolio Performance</th>
                            <th>Returns</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Since Insception - XIRR</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>FYTD - XIRR</td>
                            <td>{{FYXIRR}}</td>
                        </tr>
                        <tr>
                            <td>QTD - XIRR</td>
                            <td>{{QTXIRR}}</td>
                        </tr>
                        <tr>
                            <td>1 Year - XIRR</td>
                            <td>{{oneyearXIRR}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="NewHeadOuter DotTabsContent">
            <div class="table-responsive table-container">
                <table id="dataTable_tally_sheet" class="CommonTable ClsReportTable nowrap" width="100%">
                    <thead>
                        <tr>
                            <th>Asset Class</th>
                            <th class="text-right">Value at Cost</th>
                            <th class="text-right">Market Value</th>
                            <th>Weightage(%)</th>
                            <th class="text-right">Unrealised (Gain/Loss)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="asset-class" colspan="5">Mutual Fund</td>
                        </tr>
                        <tr>
                            <td>Debt</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td>Equity</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td>Hybrid</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td>Money Market</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td>Multi Asset</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr class="table-light">
                            <td>Total Mutual Fund</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>

                        <tr>
                            <td class="asset-class" colspan="5">Debt</td>
                        </tr>
                        <tr>
                            <td>Fixed Deposit</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td>Fixed Income</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td>Secondary Debt and Securities</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr class="table-light">
                            <td>Total Debt</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td class="asset-class" colspan="5">Linked Debenture</td>
                        </tr>
                        <tr>
                            <td>MLD/NLD</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr class="table-light">
                            <td>Total Linked Debenture</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td class="asset-class" colspan="5">Stocks/Equity</td>
                        </tr>
                        <tr>
                            <td>Stocks/Equity</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr class="table-light">
                            <td>Total Stocks/Equity</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr>
                            <td class="asset-class" colspan="5">Composite Product</td>
                        </tr>
                        <tr>
                            <td>Composite Product</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr class="table-light">
                            <td>Total Composite Product</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                        <tr class="table-light">
                            <td>Grand Total</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                            <td>XXXXXXXXXXXX</td>
                            <td class="text-right">XXXXXXXXXXXX</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>

        <div class="NewHeadOuter_faq DotTabsContent ml-3 mr-3">
            <div class="Ipos_Mob CursorPointer">
                <div class="FDCards bg-white">
                    <div class="ACCDiv">
                        <div id="accordion">
                            <div class="card">
                                <div class="card-header collapsed d-flex justify-content-between" data-toggle="collapse"
                                    data-target="#FAQ_1" aria-expanded="false"><span class="title">Initial
                                        Corpus</span><span class="accicon"><i
                                            class="fa fa-angle-right rotate-icon"></i></span>
                                </div>
                                <div id="FAQ_1" class="collapse" data-parent="#accordion">
                                    <div class="card-body">
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header collapsed d-flex justify-content-between" data-toggle="collapse"
                                    data-target="#FAQ_2" aria-expanded="false" aria-controls="FAQ_2"><span class="title">New
                                        Net
                                        Addition /
                                        Withdrawn</span><span class="accicon"><i
                                            class="fa fa-angle-right rotate-icon"></i></span>
                                </div>
                                <div id="FAQ_2" data-parent="#accordion" class="collapse">
                                    <div class="card-body">
                                        <div class="NewHeadOuter text-inner">
                                            <div>
                                                <div class="text-head">MF Portfolio Report</div>
                                            </div>
                                            <div>
                                                <div class="text-subhead">XXXXXXXXXXXX</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header collapsed d-flex justify-content-between" data-toggle="collapse"
                                    data-target="#FAQ_3" aria-expanded="false" aria-controls="FAQ_3"><span class="title">MF
                                        Realised Gain / Loss</span><span class="accicon"><i
                                            class="fa fa-angle-right rotate-icon"></i></span></div>
                                <div id="FAQ_3" data-parent="#accordion" class="collapse">
                                    <div class="card-body">
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header collapsed d-flex justify-content-between" data-toggle="collapse"
                                    data-target="#FAQ_4" aria-expanded="false" aria-controls="FAQ_4"><span class="title">MF
                                        Unrealised Gain / Loss</span><span class="accicon"><i
                                            class="fa fa-angle-right rotate-icon"></i></span></div>
                                <div id="FAQ_4" data-parent="#accordion" class="collapse">
                                    <div class="card-body">
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header collapsed d-flex justify-content-between" data-toggle="collapse"
                                    data-target="#FAQ_5" aria-expanded="false" aria-controls="#FAQ_5"><span class="title">MF
                                        Earned Dividend / Intrest</span><span class="accicon"><i
                                            class="fa fa-angle-right rotate-icon"></i></span></div>
                                <div id="FAQ_5" data-parent="#accordion" class="collapse">
                                    <div class="card-body">
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header collapsed d-flex justify-content-between" data-toggle="collapse"
                                    data-target="#FAQ_6" aria-expanded="false" aria-controls="#FAQ_6" c><span
                                        class="title">Other
                                        Income</span><span class="accicon"><i
                                            class="fa fa-angle-right rotate-icon"></i></span>
                                </div>
                                <div id="FAQ_6" data-parent="#accordion" class="collapse">
                                    <div class="card-body">
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header collapsed d-flex justify-content-between" data-toggle="collapse"
                                    data-target="#FAQ_7" aria-expanded="false" aria-controls="FAQ_7"><span
                                        class="title">Mark to
                                        Market Futures</span><span class="accicon"><i
                                            class="fa fa-angle-right rotate-icon"></i></span></div>
                                <div id="FAQ_7" data-parent="#accordion" class="collapse">
                                    <div class="card-body">
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="M-Top bg-white ml-3 mr-3 mb-3 disclaimer-box">
            <div class="row">
                <div class="col-12">
                    <p class="disclaimer-text mt-3">Investment Summary :</p>
                    <p><b>Note :</b> *Fixed Income products includes Bonds(tax saving, RBI), SGB, NCDs # For Products other
                        than MF
                        i.e. FDs, Bonds, NCDs etc., only investment values are considered; Interest rates/accrued
                        values are currently not displayed(The same will be provided post updations). # For Weightage
                        calculation- cost of investment has been considered. # Dividend transactions are considered in the
                        MF
                        investments and returns, but are not considered in transaction count. # Unreconciled Investments
                        i.e.
                        investments yet to be reported by the FD/BOND company as a valid investment, are included in
                        the report.</p>
                </div>
            </div>
        </div>

        <div class="bg-white ml-3 mr-3 mb-3 disclaimer-box d-vis">
            <div class="row">
                <div class="col-12">
                    <p class="disclaimer-text mt-3">Investment Summary :</p>

                </div>
            </div>
        </div>
    </div>


    <div class="MainBg mt-3" *ngIf="!IsMobile">
        <div class="MainInnerFormWithoutFlex mx-3">
            <div class="FormTemplate">
                <app-clients-filter (FilterData)="ClientFilterData($event)" [DDLFilterType]="DDLFilterType"
                    [DashboardUserId]="DashboardUserId">
                </app-clients-filter>
            </div>
            <div class="SubmitMarginTop">
                <button class="CommonSubmitButton" (click)="GetInvestSummary()">Show
                    Report</button>
            </div>
            <div class="SubmitMarginTop" *ngIf="PDFButton">
                <button *ngIf="!IsMobile" class="BtnCommon BtnRed BtnExport ml-2" (click)='ExportToPdf_summary()'>
                    <img src="../../assets/images/PDF_Export.svg" class="ExportToIcon" type="image/svg+xml" fill="#fff"
                        width="12px" pluginspage="http://www.adobe.com/svg/viewer/install/" /></button>
            </div>
        </div>
        <div id="divpdfnotmob">
            <!-- PDF Header -->
            <diV *ngIf="PDFPrintPriview">
                <div class="FirstPage" id="pdfHeaderFirstPage">
                    <div>
                        <img class="BannerImg" src="../../../assets/images/JM/pdf/PDFTopBanner.png" />
                    </div>
                    <div class="ReportInfo">
                        <div class="ReportName">{{ReportName}}</div>
                        <div class="ClientName">{{ClientName}}</div>
                        <div class="Address">{{Address}}</div>
                        <div class="ason">Report Generated Date</div>
                        <div class="asondate">{{Today | date:'dd-MMM-YYYY'}}</div>
                    </div>
                    <div class="FooterInfo">
                        <div>
                            <div class="q">Contact Person</div>
                            <div class="a">{{SB_IFD_Name}}</div>
                            <div class="a">{{RM_Name}}</div>
                        </div>
                        <!-- <div>
                            <div class="q">Relationship Manager</div>
                            <div class="a">{{RM_Name}}</div>
                        </div> -->
                        <div>
                            <div class="q">Helpdesk</div>
                            <div class="a">customercare@incredmarkets.com</div>
                            <div class="a">0120-4477777</div>
                        </div>
                        <div>
                            <div class="q">Generated date</div>
                            <div class="a">{{Today | date:'dd-MMM-YYYY'}}</div>
                            <div class="a">{{Today | date:'hh:mm:ss a'}}</div>
                        </div>
                    </div>
                    <div>
                        <img class="BottomImg" src="../../../assets/images/JM/pdf/PDFBottomBanner.png" />
                    </div>
                </div>
            </diV>
            <div id="DynamicContent">
                <div id="divSummary" class=" my-data-element">
                    <div class="row d-flex justify-content-between" *ngIf="ShowInvestSummReport">
                        <div class="col-2 col-sm-2 col-xs-12 col-12">
                            <div class="SubmitMarginTop ml-3">
                                <div class="SchemeHeader specialHeaders disclaimer-text">Investment Summary</div>
                            </div>
                        </div>
                        <div class="col-7 col-sm-7  col-6 col-xs-6">
                            <div class="SubmitMarginTop">
                                <div class="row Kpos">
                                    <div class="Kpos_inner">
                                        <div class="SubmitMarginTop  text-center investBoxs">
                                            <div class="SchemeHeader specialHeaders disclaimer-text">Total Value at Cost</div>
                                            <div class="SubHeader">{{TotalvalueatCost}}</div>
                                        </div>
                                    </div>
                                    <div class="Kpos_inner">
                                        <div class="SubmitMarginTop  text-center investBoxs">
                                            <div class="SchemeHeader specialHeaders disclaimer-text">Total MF Value at Cost</div>
                                            <div class="SubHeader">{{TotalMFvalueatCost}}</div>
                                        </div>
                                    </div>
                                    <div class="Kpos_inner">
                                        <div class="SubmitMarginTop  text-center investBoxs">
                                            <div class="SchemeHeader specialHeaders disclaimer-text">MF Portfolio Value</div>
                                            <div class="SubHeader">{{MFPortfoliovalue}}</div>
                                        </div>
                                    </div>
                                    <div class="Kpos_inner">
                                        <div class="SubmitMarginTop  text-center investBoxs">
                                            <div class="SchemeHeader specialHeaders disclaimer-text">Unrealised Gain / Loss</div>
                                            <div class="SubHeader">{{UnrealisedGainOrLoss}}</div>
                                        </div>
                                    </div>
                                    <div class="Kpos_inner">
                                        <div class="SubmitMarginTop  text-center investBoxs">
                                            <div class="SchemeHeader specialHeaders disclaimer-text">MF XIRR(%)</div>
                                            <!-- <div class="SchemeHeader d-vis">MF XIRR(%)</div> -->
                                            <div class="SubHeader">{{MFXirr}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-2 mr-3">
                            <div class="Kpos_inner my-3">
                                <div class="SubmitMarginTop ml-3 text-center Inceptionclass">
                                    <div class="SchemeHeader specialHeaders disclaimer-text">Inception Date</div>
                                    <div class="SubHeader">{{InsecptionDATE}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="BorderR M-Top bg-white ml-3 mr-3 mb-3" *ngIf="ShowInvestSummReport">
                        <div class="ExploreInner">
                            <div class="MFDBox CursorPointer">
                                <table id="dataTable_tally_sheet1" class="CommonTable ClsReportTable nowrap">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th class="no-sort">Asset Class</th>
                                            <th class="no-sort">Value at Cost</th>
                                            <th class="no-sort">Market Value</th>
                                            <th class="no-sort">Weightage(%)</th>
                                            <th class="no-sort">Unrealised (Gain/Loss)</th>
                                            <th class="no-sort" style="display: none;">OrderNo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of tblAssetWise">
                                            <td class="client_Name"><b class="GrandTotal">{{item.Product}}</b></td>
                                            <td>{{item.AssetClass}}</td>
                                            <td class="text-right">{{item.ValueAtCost == 0 ? '-' : ConvertToIndianRsWithoutDecimal(item.ValueAtCost)}}</td>
                                            <td class="text-right">{{item.MarketValue == 0 ? '-' : ConvertToIndianRsWithoutDecimal(item.MarketValue)}}</td>
                                            <td class="text-right">{{item.Weightage == 0 ? '-' : item.Weightage}}</td>
                                            <td class="text-right">{{item.UnrealisedGainLoss == 0 ? '-' : ConvertToIndianRsWithoutDecimal(item.UnrealisedGainLoss)}}</td>
                                            <td class="text-right" style="display: none;">{{item.orderno}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right" style="display: none;"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div>
                                <div class="TypeSection Ipo Ipos_Mob CursorPointer">
                                    <div class="ChartOuter">
                                        <!-- <div id="investmentsummaryreport"></div> -->
                                        <div id="OverallProductChart"></div>
                                    </div>
                                </div>
                                <div class="TypeSection_table_chart ETF CursorPointer ng-star-inserted">
                                    <table id="dataTable_tally_sheet" width="100%"
                                        class="CommonTable ClsReportTable nowrap">
                                        <thead>
                                            <tr>
                                                <th>MF Portfolio Performance</th>
                                                <th>Returns</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Since Inception - XIRR</td>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <td>FYTD - XIRR</td>
                                                <td>{{FYXIRR}}</td>
                                            </tr>
                                            <tr>
                                                <td>QTD - XIRR</td>
                                                <td>{{QTXIRR}}</td>
                                            </tr>
                                            <tr>
                                                <td>1 Year - XIRR</td>
                                                <td>{{oneyearXIRR}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <div class="TypeSection_faq  Ipos_Mob CursorPointer">
                                    <div class="FDCards bg-white">
                                        <!-- <div class="ACCDiv">
                                            <div id="accordion">
                                                <div class="card d-none">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_1" aria-expanded="false">
                                                        <span class="title">Initial
                                                            Corpus</span><span class="accicon"><i
                                                                class="fa fa-angle-right rotate-icon"></i></span>
                                                    </div>
                                                    <div id="FAQ_1" class="collapse" data-parent="#accordion">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card d-none">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_2" aria-expanded="false"
                                                        aria-controls="FAQ_2"><span class="title">New Net
                                                            Addition /
                                                            Withdrawn</span><span class="accicon"><i
                                                                class="fa fa-angle-right rotate-icon"></i></span>
                                                    </div>
                                                    <div id="FAQ_2" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <div class="NewHeadOuter text-inner">
                                                                <div>
                                                                    <div class="text-head">MF Portfolio Report</div>
                                                                </div>
                                                                <div>
                                                                    <div class="text-subhead">XXXXXXXXXXXX</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_3" aria-expanded="false"
                                                        aria-controls="FAQ_3"><span class="title">MF
                                                            Realised Gain / Loss</span><span
                                                            class="accicon">{{realisedGainOrLoss}}</span></div>
                                                    <div id="FAQ_3" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_4" aria-expanded="false"
                                                        aria-controls="FAQ_4"><span class="title">MF
                                                            Unrealised Gain / Loss</span><span
                                                            class="accicon">{{UnrealisedGainOrLoss}}</span></div>
                                                    <div id="FAQ_4" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_5" aria-expanded="false"
                                                        aria-controls="#FAQ_5"><span class="title">MF
                                                            Earned Dividend / Interest</span><span
                                                            class="accicon">{{MFEarnedDividend}}</span></div>
                                                    <div id="FAQ_5" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card d-none">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_6" aria-expanded="false"
                                                        aria-controls="#FAQ_6" c><span class="title">Other
                                                            Income</span><span class="accicon"><i
                                                                class="fa fa-angle-right rotate-icon"></i></span></div>
                                                    <div id="FAQ_6" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card d-none">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_7" aria-expanded="false"
                                                        aria-controls="FAQ_7"><span class="title">Mark to
                                                            Market Futures</span><span class="accicon"><i
                                                                class="fa fa-angle-right rotate-icon"></i></span></div>
                                                    <div id="FAQ_7" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="ACCDiv">
                                            <div id="accordion">
                                                <div class="card d-none">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_1" aria-expanded="false">
                                                        <span class="title">Initial
                                                            Corpus</span><span class="accicon"><i
                                                                class="fa fa-angle-right rotate-icon"></i></span>
                                                    </div>
                                                    <div id="FAQ_1" class="collapse" data-parent="#accordion">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-target="#FAQ_2" aria-expanded="false"
                                                        aria-controls="FAQ_2"><span class="title">New Net
                                                            Addition /
                                                            Withdrawn</span><span class="accicon">-</span>
                                                    </div>
                                                    <div id="FAQ_2" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <!-- <div class="NewHeadOuter text-inner">
                                                                <div>
                                                                    <div class="text-head">MF Portfolio Report</div>
                                                                </div>
                                                                <div>
                                                                    <div class="text-subhead">0</div>
                                                                </div>
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-target="#FAQ_8" aria-expanded="false" aria-controls="FAQ_8">
                                                        <span class="title">MF Portfolio Value</span><span
                                                            class="accicon">{{MFPortfoliovalue}}</span>
                                                    </div>
                                                    <div id="FAQ_8" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-target="#FAQ_3" aria-expanded="false" aria-controls="FAQ_3">
                                                        <span class="title">MF
                                                            Realised Gain / Loss</span><span
                                                            class="accicon">{{realisedGainOrLoss}}</span>
                                                    </div>
                                                    <div id="FAQ_3" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-target="#FAQ_4" aria-expanded="false" aria-controls="FAQ_4">
                                                        <span class="title">MF
                                                            Unrealised Gain / Loss</span><span
                                                            class="accicon">{{UnrealisedGainOrLoss}}</span>
                                                    </div>
                                                    <div id="FAQ_4" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-target="#FAQ_5" aria-expanded="false" aria-controls="#FAQ_5">
                                                        <span class="title">MF
                                                            Earned Dividend / Interest</span><span
                                                            class="accicon">{{MFEarnedDividend}}</span>
                                                    </div>
                                                    <div id="FAQ_5" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-target="#FAQ_6" aria-expanded="false"
                                                        aria-controls="#FAQ_6" c><span class="title">Other
                                                            Income</span><span class="accicon">-</span></div>
                                                    <div id="FAQ_6" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card d-none">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-toggle="collapse" data-target="#FAQ_7" aria-expanded="false"
                                                        aria-controls="FAQ_7"><span class="title">Mark to
                                                            Market Futures</span><span class="accicon"><i
                                                                class="fa fa-angle-right rotate-icon"></i></span></div>
                                                    <div id="FAQ_7" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card">
                                                    <div class="card-header collapsed d-flex justify-content-between"
                                                        data-target="#FAQ_9" aria-expanded="false"
                                                        aria-controls="#FAQ_9" c><span class="title">Total Gains/Losses</span><span class="accicon">{{totalprofitgain}}</span></div>
                                                    <div id="FAQ_9" data-parent="#accordion" class="collapse">
                                                        <div class="card-body">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Disclaimer -->
                    <div class="bg-white ml-3 mr-3 mb-3 disclaimer-box" *ngIf="ShowInvestSummReport">
                        <div class="row">
                            <div class="col-12">
                                <!-- <p class="disclaimer-text mt-3">Investment Summary:</p> -->
                                <p><b>Note :</b> *Fixed Income products includes Bonds(tax saving, RBI), SGB, NCDs # For
                                    Products
                                    other
                                    than MF
                                    i.e. FDs, Bonds, NCDs etc., only investment values are considered; Interest
                                    rates/accrued
                                    values are currently not displayed(The same will be provided post updations). # For
                                    Weightage
                                    calculation- cost of investment has been considered. # Dividend transactions are
                                    considered
                                    in
                                    the
                                    MF
                                    investments and returns, but are not considered in transaction count. # Unreconciled
                                    Investments
                                    i.e.
                                    investments yet to be reported by the FD/BOND company as a valid investment, are
                                    included in
                                    the report.</p>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <!-- Mutual Fund -->
                <div id="divMF" class=" my-data-element">
                    <div class="row d-flex justify-content-between" *ngIf="ShowMututalFundReport">
                        <div class="col-2 col-sm-2 col-xs-12 col-12">
                            <div class="SubmitMarginTop ml-3">
                                <div class="SchemeHeader specialHeaders disclaimer-text specialHeaders">Mutual Fund Summary
                                </div>
                            </div>
                        </div>
                        <div class="col-7 col-sm-7  col-6 col-xs-6"></div>
                        <div class="col-2 mr-3"></div>
                    </div>
                    <div class="BorderR M-Top bg-white ml-3 mr-3 mb-3" *ngIf="ShowMututalFundReport">
                        <div class="mx-3">
                            <div class="MFDBox CursorPointer marginclass">
                                <table id="dataTable_tally_sheet2" class="CommonTable ClsReportTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th class="no-sort">ClientName - Pan</th>
                                            <th class="no-sort">SC</th>
                                            <th class="no-sort">Scheme Name - Folio</th>
                                            <th class="no-sort">Units</th>
                                            <th class="no-sort">Purchase Nav</th>
                                            <th class="no-sort">Cost Value</th>
                                            <!-- <th>Current Nav / Valuation Date</th> -->
                                            <th class="text-right no-sort">
                                                <div style="display: flex;flex-direction: column;">
                                                    <div>Current Nav</div>
                                                    <hr style="margin: 0px;" />
                                                    <div>Valuation Date</div>
                                                </div>
                                            </th>
                                            <th class="no-sort">Current Value</th>
                                            <th class="no-sort">Dividend</th>
                                            <th class="no-sort">Absolute Gain/Loss</th>
                                            <th class="no-sort">Absolute Gain/Loss (%)</th>
                                            <th class="no-sort">XIRR(%)</th>
                                            <!-- <th>Average Days / First Purchase Date</th> -->
                                            <th class="text-right no-sort">
                                                <div style="display: flex;flex-direction: column;">
                                                    <div>Average Days</div>
                                                    <hr style="margin: 0px;" />
                                                    <div>First Purchase Date</div>
                                                </div>
                                            </th>
                                            <th class="no-sort">No. of Txns</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item1 of PortfolioReport">
                                            <td class=""><b class="GrandTotal">{{item1.ClientName}} - {{item1.PAN}}</b></td>
                                            <td class=""><b class="GrandTotal">{{item1.SubCategoryName}}</b></td>
                                            <td class="">{{item1.SchemeName}} - {{item1.Folio}}</td>
                                            <td class="text-right">{{item1.Unit}}</td>
                                            <td class="text-right">{{item1.PurWtAvg}}</td>
                                            <td class="text-right">
                                                {{ConvertToIndianRsWithoutDecimal(item1.CostCurrentValue)}}</td>
                                            <!-- <td class="text-right">{{item1.NAV}} / {{item1.NAVDate}}</td> -->
                                            <td class="text-right">
                                                <div style="display: flex;flex-direction: column;">
                                                    <div>{{item1.NAV}}</div>
                                                    <hr style="margin: 0px;" />
                                                    <div>{{item1.NAVDate | date:'dd-MMM-yyyy'}}</div>
                                                </div>
                                            </td>
                                            <td class="text-right">{{ConvertToIndianRsWithoutDecimal(item1.Currentvalue)}}
                                            </td>
                                            <td class="text-right">
                                                {{ConvertToIndianRsWithoutDecimal(item1.DividendReinvest)}}</td>
                                            <td class="text-right">{{ConvertToIndianRsWithoutDecimal(item1.GainLoss)}}</td>
                                            <td class="text-right">
                                                {{item1.Absreturn}}
                                            </td>
                                            <td class="text-right">{{item1.XIRR}}</td>
                                            <!-- <td class="text-right">/ {{item1.FirstPurDate}}</td> -->
                                            <td class="text-right">
                                                <div style="display: flex;flex-direction: column;">
                                                    <div>{{item1.AvgDays}}</div>
                                                    <hr style="margin: 0px;" />
                                                    <div>{{item1.FirstPurDate | date:'dd-MMM-yyyy'}}</div>
                                                </div>
                                            </td>
                                            <td class="text-right">{{item1.TotalTran}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- FD Report -->
                <div id="divFD" class=" my-data-element">
                    <div class="row d-flex justify-content-between" *ngIf="ShowFDReportReport">
                        <div class="col-2 col-sm-2 col-xs-12 col-12">
                            <div class="SubmitMarginTop ml-3">
                                <div class="SchemeHeader specialHeaders disclaimer-text specialHeaders">FD Report</div>
                            </div>
                        </div>
                        <div class="col-7 col-sm-7  col-6 col-xs-6"></div>
                        <div class="col-2 mr-3"></div>
                    </div>
                    <div class="BorderR M-Top bg-white ml-3 mr-3 mb-3" *ngIf="ShowFDReportReport">
                        <div class="mx-3">
                            <div class="MFDBox CursorPointer marginclass">
                                <table id="Fd_Mature_Datatable" class="CommonTable ClsReportTable">
                                    <thead>
                                        <tr>
                                            <th>Client Name</th>
                                            <!-- <th>Company Name</th> -->
                                            <th>Instrument Name</th>
                                            <th>Coupon/Interest Rates</th>
                                            <th>Purchase Date</th>
                                            <th>Maturity Date</th>
                                            <th>Quantity</th>
                                            <!-- <th>FD/FI Amount</th> -->
                                            <th>Value at Cost</th>
                                            <th>Accrued Interest</th>
                                            <!-- <th>FDR Number</th> -->
                                            <!-- <th>FD/FI Period</th> -->
                                            <th>FDR/Cert No</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of ClientFDDetails; let i= index">
                                            <td>{{data.CUSTOMER_NAME}}</td>
                                            <!-- <td>{{data.SCHEME_NAME}}</td> -->
                                            <td>{{data.RTA_SCHEME_NAME}}</td>
                                            <td class="text-center">-</td>
                                            <td>{{data.FD_DATE | date : 'dd-MMM-yyyy'}}</td>
                                            <td>{{data.MATURITY_DATE | date : 'dd-MMM-yyyy'}}</td>
                                            <td class="text-center">-</td>
                                            <!-- <td>{{ConvertToIndianRsWithDecimal(data.FD_AMOUNT)}}</td> -->
                                            <td>{{ConvertToIndianRsWithDecimal(data.FD_AMOUNT)}}</td>
                                            <td class="text-center">-</td>
                                            <!-- <td>{{data.FDR_NO}}</td> -->
                                            <!-- <td>{{data.FD_PERIOD}}</td> -->
                                            <td>{{data.FDR_NO}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="px-2 GrandTotal"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- AIF -->
                <div id="divAIF" class=" my-data-element">
                    <div class="row d-flex justify-content-between" *ngIf="ShowAIFReport">
                        <div class="col-2 col-sm-2 col-xs-12 col-12">
                            <div class="SubmitMarginTop ml-3">
                                <div class="SchemeHeader specialHeaders disclaimer-text specialHeaders">AIF Report</div>
                            </div>
                        </div>
                        <div class="col-7 col-sm-7  col-6 col-xs-6"></div>
                        <div class="col-2 mr-3"></div>
                    </div>
                    <div class="BorderR M-Top bg-white ml-3 mr-3 mb-3" *ngIf="ShowAIFReport">
                        <div class="mx-3">
                            <div class="MFDBox CursorPointer marginclass">
                                <table id="tblAIFSummary" class="CommonTable ">
                                    <thead>
                                        <tr>
                                            <th class="text-right">Commitment</th>
                                            <th class="text-right">Amount Contributed</th>
                                            <th class="text-right">Units Alloted</th>
                                            <th class="text-right">Outstanding Commitment</th>
                                            <th class="text-right">Capital Contributed</th>
                                            <th class="text-right">Capital Redeemed</th>
                                            <th class="text-right">GSurplus Distributed</th>
                                            <th class="text-right">Capital Balance</th>
                                            <th class="text-right">Balance Units</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let summaryVal of ClientAIFDetails; let i= index">
                                            <td class="text-right">
                                                {{ConvertToIndianRsWithoutDecimal(summaryVal.CommitmentAmount)}}
                                            </td>
                                            <td class="text-right">
                                                {{ConvertToIndianRsWithoutDecimal(summaryVal.ContributedAmount)}}
                                            </td>
                                            <td class="text-right">{{summaryVal.UnitAllote}}</td>
                                            <td class="text-right">
                                                {{ConvertToIndianRsWithoutDecimal(summaryVal.OutstandingCommitment)}}</td>
                                            <td class="text-right">
                                                {{ConvertToIndianRsWithoutDecimal(summaryVal.CapitalContribute)
                                                }}</td>
                                            <td class="text-right">{{summaryVal.CapitalRedeem }}</td>
                                            <td class="text-right">{{summaryVal.Surplusdistribute}}</td>
                                            <td class="text-right">
                                                {{ConvertToIndianRsWithoutDecimal(summaryVal.BalanceCapital)}}
                                            </td>
                                            <td class="text-right">{{summaryVal.BalanceUnits}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- PMS -->
                <div id="divPMS" class=" my-data-element">
                    <div class="row d-flex justify-content-between" *ngIf="ShowPMSReport">
                        <div class="col-2 col-sm-2 col-xs-12 col-12">
                            <div class="SubmitMarginTop ml-3">
                                <div class="SchemeHeader specialHeaders disclaimer-text specialHeaders">PMS Report</div>
                            </div>
                        </div>
                        <div class="col-7 col-sm-7  col-6 col-xs-6"></div>
                        <div class="col-2 mr-3"></div>
                    </div>
                    <div class="BorderR M-Top bg-white ml-3 mr-3 mb-3" *ngIf="ShowPMSReport">
                        <div class="mx-3">
                            <div class="MFDBox CursorPointer marginclass">
                                <table id="tblPMSHoldingReport" class="CommonTable ClsReportTable w-100">
                                    <thead>
                                        <tr>
                                            <th>Scheme Name</th>
                                            <th>Account No.</th>
                                            <th class="text-right">Invested Amount</th>
                                            <th class="text-right">Current Values</th>
                                            <th class="text-right">Absolute Gain/Loss (Rs)</th>
                                            <th class="text-right">Valuation Date</th>
                                            <th>Asset Type</th>
                                            <th class="text-right">Weightage to Total Portfolio(%)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of ClientPMSDetails; let i= index">
                                            <td>{{data.SchemeName}}</td>
                                            <td>{{data.AccountNumber}}</td>
                                            <td class="text-right">{{ConvertToIndianRsWithoutDecimal(data.InvestedAmount)}}
                                            </td>
                                            <td class="text-right">{{ConvertToIndianRsWithoutDecimal(data.CurrentAmount)}}
                                            </td>
                                            <td class="text-right">{{ConvertToIndianRsWithoutDecimal(data.AbsGainLossRs)}}
                                            </td>
                                            <td class="text-right">{{data.ValuationDate | date : 'dd-MMM-yyyy'}}</td>
                                            <td>{{data.AssetType}}</td>
                                            <td class="text-right">{{data.AbsGainLossPer}}</td>
                                            <!-- /<td class="text-right">{{ConvertToIndianRsWithoutDecimal(data.InvestedAmount)}}</td> -->
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                            <td class="text-right px-2 GrandTotal"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="MainInnerFormWithoutFlex mx-3" [hidden]="NoDataFound" id="divnorecord" style="height: 300px;">
                <h3>No Record Found!</h3>
            </div>
            <!-- PDF Footer -->
            <!-- <footer class="LastPage" *ngIf="PDFPrintPriview">
                <div class="FooterInfo">
                    <div class="container">
                        <div class="row footertxt">
                            <div class="col-4">
                                <div class="b text-upper cl-name">Client Name: <b>{{ClientName}}</b></div>
                            </div>
                            <div class="col-4">
                                <div class="b text-upper sb-name">SubBroker Name: <b>{{SB_IFD_Name}}</b></div>
                            </div>
                            <div class="col-4">
                                <div class="b datee">Date: <b>{{Today | date:'dd-MMM-YYYY'}}</b></div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer> -->
            <div class="LastPage" *ngIf="PDFPrintPriview">
                <div class="FooterInfo ifdDetails">
                    <div>
                        <div class="q">Client Name</div>
                        <div class="a text-upper">{{ClientName}}</div>
                    </div>
                    <div>
                        <div class="q">Report Generated Date</div>
                        <div class="a">{{Today | date:'dd-MMM-YYYY'}}</div>
                    </div>
                    <div>
                        <img class="LogoImg" src="../../../assets/images/InCred_capital_NewLogo.svg" />
                    </div>
                </div>
                <div class="FooterContent">
                    <div class="Disclaimer ">Disclaimer</div>
                    <div class="Content">
                        This Statement/Report has been prepared based on the information
                        available with Incred Markets (Incred Markets) and/or the data
                        provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers,
                        Companies, any other external agencies, etc. which Incred Markets believes to
                        be reliable. The incorrect or insufficient data received from the
                        above sources may lead to incomplete/inaccurate Statement/Report.
                        The data in this Statement/Report, including but not limited to NAVs,
                        is subject to revision/rectification by Incred Markets/ RTA /
                        AMC/Issuers/Companies, etc. at any point of time.
                        Incred Markets reserves the right to update the Statement/Report at
                        such frequency as it may deem fit and also reserves the right
                        to amend and/or rectify the discrepancies, if any, in this
                        Statement/Report at any time without assigning any reason whatsoever.
                        As a result of such revision/rectification, the data made available
                        in this Statement/Report prior to such rectification/revision may
                        undergo change. The above Statement/Report is not available on a
                        real time basis. Incred Markets or any of its directors, employees or agents
                        take no responsibility for any inaccuracy or incompleteness in this
                        Statement/Report. For taking any investment decision including,
                        but not limited to, redemptions and switches, Independent Financial
                        Distributor (MA)/investor is requested to always refer/rely on the
                        Statement of Account provided by AMC/Registrars. Note: 1. For Mutual
                        Fund (MF), this statement summarises total holdings at scheme & folio
                        level for your client, based on transactional data available from
                        AMCs/RTAs as on report generation date. 2. Latest available NAV is
                        taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last
                        reported
                        NAV
                        will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance
                        units) x
                        (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on
                        transactions
                        prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss
                        values in
                        this statement contains Dividend, hence it may not exactly match with the values in Capital
                        Gain/Loss
                        statement.
                    </div>
                    <div class="Regd">
                        <div><span>Incred Markets</span></div>
                        <!-- <div><span>Regd Off: </span>7th Floor, Appasaheb Marathe Marg,Prabhadevi, Mumbai - 400 025.
                            Telephone :
                            022- 66303030 Fax: 022- 6630 3223, CIN:U67120MH1998PLC115415, ARN-0002</div> -->
                    </div>
                </div>
                <div>
                    <img class="BottomImg" src="../../../assets/images/JM/pdf/PDFBottomBanner.png" />
                </div>
            </div>
        </div>
    </div>